import React from 'react';
import ToolPageLayout from '../tools/ToolPageLayout';
import BriefGenerator from './BriefGenerator';
import './BriefGenerator.css';

const BriefGeneratorPage = () => (
  <ToolPageLayout
    pageTitle="Генератор брифа — MARKET DIR"
    title={
      <>
        Генератор
        <br />
        <em>брифа</em>
      </>
    }
    lead="Ответьте на вопросы — получите готовый бриф, который можно скопировать и отправить специалисту. Займёт 5–7 минут."
    headerTag="Бриф"
    wide
    showEyebrow={false}
  >
    <BriefGenerator />
  </ToolPageLayout>
);

export default BriefGeneratorPage;
